<app-text-field
  #textfield
  class="w-full"
  [formControl]="searchField"
  [placeholderIcon]="'search'"
  [placeholder]="placeholderTranslationKey | translate"
  [clearButtonEnabled]="true"
  (valueChanges)="clear($event)">
</app-text-field>
